export default {
  drawer: null,
  color: 'success',
  image: '/static/tunnels/sidebar.jpg',
}
